import React from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import Header3 from './components/Header3'
import TopBarProgress from 'react-topbar-progress-indicator'
import ClipLoader from 'react-spinners/ClipLoader'
import Modal from 'react-bootstrap/Modal'
import NumberFormat from 'react-number-format'
import { v4 as uuidv4 } from 'uuid'
import { BsShield, BsShieldLock } from 'react-icons/bs'
import { ImMan } from 'react-icons/im'
import { FaChild } from 'react-icons/fa'
import { BiMenu } from 'react-icons/bi'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'
var QRCode = require('qrcode.react')

class Ticketdownload extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      details: [],
      query: '',
      loadBarProgress: true,
      spinning: 'none',
      updateDisplay: 'block',
      resumeModal: false,
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    const businessname = localStorage.getItem('businessname')
    const accounttype = localStorage.getItem('accounttype')
    const businessid = localStorage.getItem('businessid')
    const eventid = localStorage.getItem('eventid')
    document.title = 'Ticket print - ' + businessname
    const ticketLimit = localStorage.getItem('ticketLimit')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=TICKETREADYTODOWNLOAD&eventid=${eventid}&ticketLimit=${ticketLimit}&reprint=${localStorage.getItem(
        'ticketPrint'
      )}`,
      { withCredentials: true }
    )
      .then((response) => {
        if (response.data.val == 0) {
          this.setState({ details: [], loadBarProgress: false })
        } else {
          this.setState({ details: response.data, loadBarProgress: false })
        }
      })
      .catch((error) => console.log(error))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  titleCase = (str) =>
    str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

  details = () => {
    let activeString = ''
    const accountid = localStorage.getItem('businessid')
    const businessname = localStorage.getItem('businessname')
    const accounttype = localStorage.getItem('accounttype')
    let ticketnumber = ''
    return (
      <div className=" vertical-scroll-mobile p-0">
        <table width="100%" border={0}>
          <tr style={{ background: '#fff', border: 'hidden' }}>
            <td className="p-0">
              <div>
                {this.state.details.length < 1 ? (
                  <div>
                    <label
                      style={{
                        width: '100%',
                        textAlign: 'center',
                        fontSize: 13.5,
                        color: '#5B7083',
                      }}
                    >
                      Your tickets are already printed.
                      <br />
                      If this is not the case, please dial <span>+27 78 236 5403</span> for
                      assistance.{' '}
                    </label>
                  </div>
                ) : (
                  this.state.details.map((item, index) => {
                    ticketnumber = uuidv4().toUpperCase().substr(0, 7)
                    return (
                      <div className={'col-lg-12 p-0'}>
                        <div className="w-100 p-0 mb-2">
                          <div className="w-100">
                            <div className="row" style={{ display: 'flex' }}>
                              <div className="col-12" style={{ cursor: 'pointer' }}>
                                <div style={{ width: '100%' }}>
                                  <table
                                    width={'100%'}
                                    align={'center'}
                                    cellpadding={0}
                                    cellspacing={0}
                                    style={{ fontFamily: 'arial' }}
                                    className="ticket"
                                  >
                                    <tr
                                      style={{
                                        background: 'rgb(242, 242, 242, 0.9)',
                                      }}
                                    >
                                      <th
                                        rowspan={5}
                                        style={{
                                          color: '#333',
                                          textAlign: 'center',
                                          fontWeight: 400,
                                          fontSize: 15,
                                          backgroundImage: `url("${API_URL}/logok.png")`,
                                          backgroundSize: 'cover',
                                          // border: "thin solid #f3f4f4",
                                          paddingLeft: '15',
                                          paddingRight: '15',
                                          borderTopLeftRadius: 0,
                                          borderBottomLeftRadius: 0,
                                          borderTopRightRadius: 15,
                                          borderBottomRightRadius: 15,
                                        }}
                                      >
                                        <label
                                          style={{
                                            fontSize: 15,
                                            marginTop: 13,
                                            padding: 8,
                                            paddingLeft: 10,
                                            paddingRight: 10,
                                            border: 'thin solid #e61d25',
                                            backgroundColor: 'transparent',
                                            color: '#e61d25',
                                            borderRadius: 100,
                                          }}
                                        >
                                          Event dates
                                        </label>
                                        <br />
                                        <label style={{ marginTop: 10 }}>
                                          {item.eventdate}{' '}
                                          <span style={{ fontWeight: 400 }}>
                                            {item.eventmonth}, {item.eventyear}
                                          </span>
                                        </label>
                                        <br />

                                        <table
                                          width={'100%'}
                                          style={{
                                            fontSize: 17,
                                            marginTop: 0,
                                            padding: 10,
                                            textAlign: 'center',
                                            border: 'hidden',
                                          }}
                                          cellspacing={0}
                                          cellpadding={0}
                                          border={0}
                                        >
                                          <tr
                                            style={{
                                              backgroundColor: 'transparent',
                                            }}
                                          >
                                            <td
                                              width={'25%'}
                                              style={{
                                                fontSize: 14,
                                                fontWeight: 400,
                                                paddingBottom: 0,
                                                backgroundColor: 'transparent',
                                              }}
                                              cellspacing={0}
                                              cellpadding={0}
                                            >
                                              <b>Time:</b>{' '}
                                              <label className="mb-0" style={{ color: 'grey' }}>
                                                {item.starttime} - {item.finishtime}
                                              </label>
                                            </td>
                                          </tr>
                                          <tr
                                            style={{
                                              border: 'hidden',
                                              backgroundColor: 'transparent',
                                            }}
                                          >
                                            <td
                                              style={{
                                                fontSize: 14,
                                                fontWeight: 400,
                                                border: 'hidden',

                                                overflowWrap: 'break-word',
                                                wordWrap: 'break-word',
                                                width: '10%',
                                              }}
                                            >
                                              <b>Venue:</b>
                                              <br />
                                              <label
                                                style={{
                                                  color: 'grey',
                                                  paddingTop: 5,
                                                  fontWeight: 400,
                                                }}
                                              >
                                                {item.venue.split(',').join('\r\n')}
                                              </label>
                                            </td>
                                          </tr>
                                        </table>

                                        <table
                                          align={'center'}
                                          style={{
                                            width: '100%',
                                            marginTop: 15,
                                            borderRadius: 100,
                                            color: '#fff',
                                            padding: 10,
                                          }}
                                        >
                                          <tr
                                            style={{
                                              backgroundColor: 'transparent',
                                            }}
                                          >
                                            <td
                                              style={{
                                                borderTop: 'thin solid #dcdcdc',
                                                textAlign: 'center',
                                                marginTop: 15,
                                                paddingTop: 15,
                                                border: 'hidden',
                                              }}
                                            >
                                              <b
                                                style={{
                                                  color: '#e61d25',
                                                  fontSize: 13,
                                                  fontWeight: 400,
                                                }}
                                              >
                                                Powered by
                                              </b>
                                              <br />
                                              <img
                                                src={`${API_URL}/malelogo.png`}
                                                width={100}
                                                style={{
                                                  marginBottom: 5,
                                                  marginTop: 5,
                                                }}
                                              />
                                              <br />
                                              <label
                                                style={{
                                                  color: '#e61d25',
                                                  marginTop: 3,
                                                  fontSize: 12,
                                                  fontWeight: 400,
                                                }}
                                              >
                                                Hosting an event?
                                                <br />
                                                <b style={{ color: '#e61d25' }}>WhatsApp:</b> +27 78
                                                236 5403
                                              </label>
                                            </td>
                                          </tr>
                                        </table>
                                      </th>

                                      <th
                                        colspan={2}
                                        width={'60%'}
                                        style={{
                                          borderBottom: 'thin solid #fff',
                                          background: '#e61d25',
                                          fontSize: 20,
                                          color: '#fff',
                                          textAlign: 'center',
                                          padding: 10,
                                          paddingTop: 10,
                                          paddingBottom: 10,
                                        }}
                                      >
                                        {this.titleCase(localStorage.getItem('eventname'))}
                                        <br />
                                        <span
                                          style={{
                                            fontWeight: 400,
                                            color: '#fff',
                                            fontSize: 15,
                                          }}
                                        >
                                          Hosted by {item.organiserName || businessname}
                                        </span>
                                      </th>

                                      <th
                                        style={{
                                          background: '#e61d25',
                                          borderLeft: 'thin dashed #fff',
                                          borderBottom: 'thin solid #fff',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <label
                                          style={{
                                            padding: 5,
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            background: '#fff',
                                            color: '#e61d25',
                                            textAlign: 'center',
                                            fontSize: 12,
                                            fontWeight: 500,
                                            borderRadius: 5,
                                            borderBottom: 'thin solid yellow',
                                          }}
                                        >
                                          {index + 1}
                                        </label>
                                      </th>
                                    </tr>

                                    <tr
                                      style={{
                                        background: '#e61d25',
                                        textAlign: 'center',
                                        fontSize: 13,
                                      }}
                                    >
                                      <td
                                        style={{
                                          padding: 0,
                                          borderBottom: 'thin solid #fff',
                                          color: '#fff',
                                          paddingBottom: 10,
                                          paddingTop: 10,
                                        }}
                                      >
                                        <b>Customer details</b>
                                      </td>
                                      <td
                                        style={{
                                          padding: 0,
                                          borderBottom: 'thin solid #fff',
                                          borderLeft: 'thin solid #fff',
                                          color: '#fff',
                                        }}
                                      >
                                        <b> Cost details</b>
                                      </td>

                                      <td
                                        rowSpan={4}
                                        width={'15%'}
                                        style={{
                                          padding: 0,
                                          borderLeft: 'thin dashed #fff',
                                          borderTop: 'thin solid #fff',
                                          borderRight: 'hidden',
                                          textAlign: 'center',
                                          color: '#fff',
                                          fontSize: 13,
                                          paddingLeft: 20,
                                          paddingRight: 20,
                                        }}
                                      >
                                        <label className="mb-0 mt-3 font-size-12 color-white">
                                          Scan Here
                                        </label>
                                        <br />
                                        <div
                                          className="mt-2 mb-2"
                                          style={{
                                            justifyContent: 'center',
                                            padding: '10px',
                                            backgroundColor: '#fff',
                                            display: 'inline-block',
                                            borderRadius: '8px',
                                          }}
                                        >
                                          <QRCode
                                            value={item.qr_payload}
                                            logoSize={0}
                                            size={140}
                                            // quietZone={10}
                                          />
                                        </div>
                                        <br />
                                        {item.ticketnumber}
                                        <br />
                                        <label
                                          style={{
                                            color: '#e61d25',
                                            fontWeight: 400,
                                            background: '#ffffff',
                                            borderRadius: 100,
                                            padding: 5,
                                            paddingLeft: 10,
                                            paddingRight: 10,
                                            fontSize: 12,
                                            marginTop: 5,
                                          }}
                                        >
                                          {item.age_group == 1 ? <>Child</> : <>Adult</>}
                                        </label>
                                      </td>
                                    </tr>
                                    <tr style={{ background: '#e61d25' }}>
                                      <td
                                        style={{
                                          padding: 0,
                                          borderBottom: 'thin solid #fff',
                                          textAlign: 'center',
                                          fontSize: 13,
                                          paddingLeft: 20,
                                          paddingRight: 20,
                                          paddingTop: 10,
                                          paddingBottom: 10,
                                        }}
                                      >
                                        <span style={{ color: '#fff' }}>Issued to:</span>{' '}
                                        <span
                                          style={{
                                            fontWeight: 400,
                                            color: '#fff',
                                          }}
                                        >
                                          Customer
                                        </span>
                                        <br />
                                        <br />
                                        <span style={{ color: '#fff' }}>Ticket holder:</span>{' '}
                                        <span
                                          style={{
                                            fontWeight: 400,
                                            color: '#fff',
                                          }}
                                        >
                                          Customer
                                        </span>
                                      </td>

                                      <td
                                        style={{
                                          padding: 0,
                                          borderBottom: 'thin solid #fff',
                                          borderRight: 'thin dashed #fff',
                                          borderLeft: 'thin solid #fff',
                                          color: '#fff',
                                          textAlign: 'center',
                                          fontSize: 13,
                                          paddingLeft: 30,
                                          paddingRight: 30,
                                        }}
                                      >
                                        <span style={{ color: '#fff' }}>Ticket price:</span>{' '}
                                        <span
                                          style={{
                                            fontWeight: 400,
                                            color: '#fff',
                                          }}
                                        >
                                          R
                                          {parseInt(item.age_group) == 1
                                            ? Number(item.kids_price).toFixed(2)
                                            : Number(item.price).toFixed(2)}
                                        </span>
                                        <br />
                                        <br />
                                        <span style={{ color: '#fff' }}>Total:</span>{' '}
                                        <span
                                          style={{
                                            fontWeight: 400,
                                            color: '#fff',
                                          }}
                                        >
                                          R
                                          {parseInt(item.age_group) == 1
                                            ? Number(item.kids_price).toFixed(2)
                                            : Number(item.price).toFixed(2)}
                                        </span>
                                      </td>
                                    </tr>

                                    <tr
                                      style={{
                                        background: '#e61d25',
                                        textAlign: 'center',
                                        fontSize: 13,
                                      }}
                                    >
                                      <td
                                        style={{
                                          color: '#fff',
                                          borderBottom: 'thin solid #fff',
                                        }}
                                      >
                                        <span>Type: </span>{' '}
                                        {item.category == 'vip'
                                          ? 'VIP'
                                          : item.category == 'vvip'
                                          ? 'VVIP'
                                          : 'General'}
                                        <br />
                                        <b style={{ color: '#fff' }}>Admission:</b> 1
                                      </td>
                                      <td
                                        style={{
                                          color: '#fff',
                                          borderRight: 'thin dashed #fff',
                                          borderLeft: 'thin solid #fff',
                                          borderBottom: 'thin solid #fff',
                                        }}
                                      >
                                        <span>Organiser's email</span>
                                        <br />
                                        {item.organiser_email}
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        background: '#e61d25',
                                        textAlign: 'center',
                                        fontSize: 13,
                                      }}
                                    >
                                      <td
                                        style={{
                                          color: '#fff',
                                        }}
                                      >
                                        <b style={{ color: '#fff' }}>Security Notice</b>
                                        <br /> Do not share this ticket publicly
                                      </td>
                                      <td
                                        style={{
                                          color: '#fff',
                                          borderRight: 'thin dashed #fff',
                                          borderLeft: 'thin solid #fff',
                                        }}
                                      >
                                        <span>Signature</span>
                                        <br />
                                        {item.qr_payload.split('.')[1].slice(0, 8)}
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                )}
              </div>
            </td>
          </tr>
        </table>
      </div>
    )
  }

  confirm = () => {
    this.setState({ resumeModal: true })
  }

  download = () => {
    this.props.history.push({
      pathname: '/download',
      state: {
        reprint: 'no',
      },
    })
  }

  closeModal = () => {
    this.setState({
      resumeModal: false,
    })
  }

  cancel = () => {
    this.setState({
      resumeModal: false,
    })
  }

  render() {
    if (localStorage.getItem('businessid') === null) {
      return <Redirect to="/login" />
      //   return exit(1),
    } else {
    }

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile, loadBarProgress } = this.state
    return (
      <div className="view">
        {loadBarProgress && <TopBarProgress />}
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : (
          <Header5 />
        )}
        <div
          className="main-content"
          style={{
            marginTop: 40,
            marginLeft: this.state.isMobile ? '0px' : this.state.collapsed ? '40px' : '240px',
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div className="mobile-overlay active" onClick={this.handleToggle} />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <Modal show={this.state.resumeModal} onHide={this.closeModal}>
            <div className="col-10 pt-4 pb-2 pl-4 pr-4">
              <div className="row justify-content-center align-self-center">
                <div className="col-12 text-center mb-4">
                  <label className="small-details mb-0">
                    <label className="mb-0 small-details">
                      <span>R{Number(localStorage.getItem('costs')).toFixed(2)}</span> will be
                      deducted from your current balance, and your balance is{' '}
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={localStorage.getItem('balance')}
                        prefix="R"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        fixedDecimalScale={true}
                      />
                      .<br />
                      <br />
                      Are you sure you want to download these tickets?
                    </label>
                  </label>
                </div>

                <div className="save-btn btn-radius-3 mb-4 mr-2" onClick={() => this.download()}>
                  <span
                    style={{
                      display: this.state.updateDisplay,
                    }}
                  >
                    Download
                  </span>
                  <span
                    style={{
                      display: this.state.spinning,
                    }}
                  >
                    <ClipLoader
                      color={'#fff'}
                      loading={true}
                      // css={override}
                      size={20}
                    />
                  </span>
                </div>

                <label
                  type="button"
                  className="cancel-btn  btn-radius-3 mb-4 mr-2"
                  onClick={() => this.cancel()}
                >
                  Cancel
                </label>
              </div>
            </div>
          </Modal>
          <div className="row justify-content-center just-container-insid">
            <div className="col-lg-11 pl-0 pr-0">
              <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
                <div className="row align-self-center justify-content-center align-items-center">
                  <div className="item-list p-0 w-100">
                    <div className="row w-100">
                      <div className="col-lg-5 col-6 pl-3 pt-2 pr-3">
                        <label className="pl-2 pr-2 mb-0 link-bt">
                          <span>{this.titleCase(localStorage.getItem('eventname'))}</span>
                        </label>
                      </div>

                      <div
                        className="col-lg-7 col-6 justify-content-end pr-3 pl-3"
                        style={{ display: 'flex' }}
                      >
                        <button type="button" className="save-btn" onClick={() => this.confirm()}>
                          <span
                            style={{
                              display: this.state.updateDisplay,
                            }}
                          >
                            Download
                          </span>
                          <span
                            style={{
                              display: this.state.spinning,
                            }}
                          >
                            <ClipLoader
                              color={'#fff'}
                              loading={true}
                              // css={override}
                              size={20}
                            />
                          </span>
                        </button>
                      </div>
                      <div className="col-12 p-0">
                        <div className="h-divider w-100" />
                      </div>
                      <div className="col-12 pr-3 pl-3">
                        <label className="mb-0">
                          Number of tickets prepared:{' '}
                          <label className="small-details">
                            {localStorage.getItem('ticketPrint')}
                          </label>
                          <br />
                          Estimated revenue after sales:{' '}
                          <label className="small-details">
                            R{localStorage.getItem('estimatedRevenue')}
                          </label>
                          <br />
                          Cost per ticket print: <label className="small-details">R1.0</label>
                          <br />
                          Total cost for {localStorage.getItem('ticketPrint')} tickets print:{' '}
                          <label className="small-details">R{localStorage.getItem('costs')}</label>
                          {/* <label className="b-0 small-details">
                            <span>NB:</span> ZAR {localStorage.getItem("costs")}{" "}
                            will be deducted from your budget.
                          </label> */}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer mb-5 pl-2 pr-2">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0 W-100">
                    <div className="col-lg-12 pl-0 pr-0">
                      <label className="ticket-title pl-0 pr-0">
                        {localStorage.getItem('ticketPrint')} TICKETS READY TO DOWNLOAD
                      </label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                {this.details()}
              </div>
            </div>
          </div>
        </div>

        {/* <Footer /> */}
      </div>
    )
  }
}

export default Ticketdownload
